import React, { useEffect } from "react";
import banner from "../images/aboutimages/banners.png";
import productimg from "../images/aboutimages/Rectangle 90.png";
import capbgbanner from "../images/aboutimages/Group 190.png";
import smallleftimg from "../images/aboutimages/Rectangle 37.png";
import smallcapbgbanner from "../images/aboutimages/Rectangle 91.png";
import founder1 from "../images/aboutimages/Mask group.png";
import founder2 from "../images/aboutimages/Mask group (1).png";
import founder3 from "../images/aboutimages/Mask group (2).png";
import vector1 from "../images/aboutimages/Vector (1).png";
import vector2 from "../images/aboutimages/Vector.png";
import vector3 from "../images/aboutimages/Group (1).png";
import founderdummy from "../images/aboutimages/Group 22.png";
import { Link } from "react-router-dom";
import backcover from "../images/aboutimages/frames.png"; // ← only this is a CSS bg
import about_s from "../images/aboutimages/abt_s.jpeg";
import { Helmet } from "react-helmet";

const About_us = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

  return (
    <div className="font-poppins overflow-x-hidden">
      <Helmet>
        <title>
          About Us | Online Medical Store, Online Medicine Order, Fastest
          Delivery | MediSYS Pharmacy
        </title>
        <meta
          name="description"
          content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store and experience the fastest home delivery."
        />
        <meta
          name="keywords"
          content="pharmacy, medical stores, online pharmacy, online pharmacy India, best online pharmacy, online pharmacy hyderabad, online medical store, online medicine store, online medical shop, online medical store hyderabad"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Online Medical Store, Online Medicine Order, Fastest Delivery | MediSYS Pharmacy"
        />
        <meta
          property="og:description"
          content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store and experience the fastest home delivery."
        />
      </Helmet>

      <section className="hidden md:block relative h-[380px] lg:h-[480px] overflow-hidden">
        {/* <img
          src={banner}
          alt="About MediSYS Banner"
          className="w-full h-full object-cover"
        /> */}
        <video autoPlay loop muted playsInline
  className="absolute inset-0 w-full h-full object-cover">
  <source src={require("../../src/images/360degreeabout.mp4")} type="video/mp4" />
  <img src={banner} alt="About MediSYS Banner" /> 
</video>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1715]/85 via-[#162c2a]/60 to-transparent" />

        <div className="absolute inset-0 flex flex-col justify-center px-10 lg:px-24">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[11px] lg:text-[12px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
              Our Story
            </span>
          </div>
          <h1 className="font-bold text-white text-[32px] lg:text-[54px] leading-tight max-w-[520px]">
            Caring for <br />
            <span className="text-[#5fbdb3]">Your Health</span>
          </h1>
          <p className="mt-3 text-[14px] lg:text-[17px] text-white/70 font-medium max-w-[380px]">
            Discover Our Commitment at MediSYS Pharmacy
          </p>
          <Link to="/products" className="mt-6 inline-block">
            <button className="flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-semibold text-[14px] lg:text-[15px] px-6 lg:px-8 h-[44px] lg:h-[50px] rounded-xl transition-all duration-200 shadow-[0_4px_18px_rgba(255,96,30,0.4)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.55)] hover:-translate-y-0.5">
              Shop Now
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </Link>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent" />
      </section>

      {/* ══════════════════════════════════════════
          HERO — Mobile  (about_s as <img>)
      ══════════════════════════════════════════ */}
      <section className="block md:hidden relative h-[280px] sm:h-[320px] overflow-hidden">
        {/* about_s displayed as an <img>, same as original */}
        <img
          src={about_s}
          alt="About MediSYS"
          className="w-full h-full object-cover opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1715]/80 via-[#162c2a]/55 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-center px-5">
          <span className="text-[10px] font-semibold uppercase tracking-widest text-[#5fbdb3] mb-2">
            Our Story
          </span>
          <h1 className="font-bold text-white text-[24px] sm:text-[28px] leading-tight">
            Caring for <span className="text-[#5fbdb3]">Your Health</span>
          </h1>
          <p className="mt-2 text-[12px] text-white/70 font-medium">
            Discover Our Commitment at MediSYS
          </p>
          <Link to="/products" className="mt-4 inline-block">
            <button className="flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-semibold text-[13px] px-5 h-[40px] rounded-xl transition-all duration-200 shadow-[0_3px_12px_rgba(255,96,30,0.4)]">
              Shop Now
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </Link>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent" />
      </section>

      {/* ══════════════════════════════════════════
          ABOUT SECTION
          capbgbanner, smallleftimg, productimg,
          smallcapbgbanner — all as <img> tags
          exactly like the original
      ══════════════════════════════════════════ */}
      <section className="bg-white py-10 sm:py-14 lg:py-16 px-5 sm:px-8 lg:px-20">
        <div className="max-w-[1200px] mx-auto">
          {/* ── Section label + heading ── */}
          <div className="mb-8 sm:mb-10">
            <div className="flex items-center gap-3 mb-2">
              <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
              <span className="text-[11px] font-semibold uppercase tracking-widest text-[#ff601e]">
                Overview
              </span>
            </div>
            <h2 className="font-bold text-[32px] sm:text-[42px] lg:text-[50px] text-[#1e4a46] leading-tight">
              About Us
            </h2>
          </div>

          {/* ── Two col: text left, feature cards right ── */}
          <div className="flex flex-col lg:flex-row lg:gap-14 lg:items-start mb-8 lg:mb-12">
            {/* Left — description with decorative bg elements */}
            <div className="w-full lg:w-1/2 order-2 lg:order-1 relative">
              {/* Decorative teal quote mark behind text */}
              <svg
                className="absolute -top-4 -left-3 w-16 h-16 text-[#eaf4f3] pointer-events-none select-none hidden sm:block"
                viewBox="0 0 60 60"
                fill="currentColor"
              >
                <path d="M0 30C0 13.4 13.4 0 30 0v10C19 10 10 19 10 30h10v20H0V30zm30 0C30 13.4 43.4 0 60 0v10C49 10 40 19 40 30h10v20H30V30z" />
              </svg>

              <p className="relative text-[#374747] text-[14px] sm:text-[15px] leading-[1.9] text-justify pl-0 sm:pl-2">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularized in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </p>

              {/* Decorative pill row below paragraph */}
              <div className="flex flex-wrap gap-2 sm:gap-3 mt-6">
                {[
                  {
                    color: "bg-[#eaf4f3] border-[#d4ecea] text-[#1e4a46]",
                    svg: (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      </svg>
                    ),
                    label: "Licensed Pharmacy",
                  },
                  {
                    color: "bg-[#fff3ee] border-[#ffd5c2] text-[#ff601e]",
                    svg: (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="1" y="3" width="15" height="13" rx="2" />
                        <path d="M16 8h4l3 5v3h-7V8z" />
                        <circle cx="5.5" cy="18.5" r="2.5" />
                        <circle cx="18.5" cy="18.5" r="2.5" />
                      </svg>
                    ),
                    label: "Fast Home Delivery",
                  },
                  {
                    color: "bg-[#eaf4f3] border-[#d4ecea] text-[#1e4a46]",
                    svg: (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                    ),
                    label: "100% Genuine Medicines",
                  },
                  {
                    color: "bg-[#fff3ee] border-[#ffd5c2] text-[#ff601e]",
                    svg: (
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    ),
                    label: "Expert Pharmacists",
                  },
                ].map((b) => (
                  <div
                    key={b.label}
                    className={`flex items-center gap-2 ${b.color} border rounded-xl px-3 sm:px-4 py-2 sm:py-2.5 transition-all duration-200 hover:shadow-md hover:-translate-y-0.5`}
                  >
                    {b.svg}
                    <span className="text-[11px] sm:text-[12px] font-semibold whitespace-nowrap">
                      {b.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — icon feature cards */}
            <div className="w-full lg:w-1/2 order-1 lg:order-2 grid grid-cols-2 gap-3 sm:gap-4 mb-8 lg:mb-0">
              {[
                {
                  bg: "bg-[#162c2a]",
                  iconBg: "bg-[#ff601e]",
                  title: "5+ Years of Trust",
                  desc: "Serving Hyderabad with quality medicines since 2018",
                  svg: (
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  ),
                },
                {
                  bg: "bg-[#ff601e]",
                  iconBg: "bg-white/20",
                  title: "5 Branch Locations",
                  desc: "Panjagutta, Manikonda, Bandlaguda & more",
                  svg: (
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                      <polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  ),
                },
                {
                  bg: "bg-[#eaf4f3]",
                  iconBg: "bg-[#1e4a46]",
                  title: "Online Prescriptions",
                  desc: "Upload your Rx and get medicines at your door",
                  svg: (
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="12" y1="18" x2="12" y2="12" />
                      <line x1="9" y1="15" x2="15" y2="15" />
                    </svg>
                  ),
                  textDark: true,
                },
                {
                  bg: "bg-[#1e4a46]",
                  iconBg: "bg-[#5fbdb3]/30",
                  title: "24/7 Availability",
                  desc: "Order medicines anytime from our online store",
                  svg: (
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                    </svg>
                  ),
                },
              ].map((card, i) => (
                <div
                  key={i}
                  className={`${card.bg} rounded-2xl p-4 sm:p-5 flex flex-col gap-3 shadow-[0_4px_18px_rgba(22,44,42,0.10)] hover:shadow-[0_8px_28px_rgba(22,44,42,0.18)] hover:-translate-y-0.5 transition-all duration-200 group`}
                >
                  {/* Icon */}
                  <div
                    className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl ${card.iconBg} flex items-center justify-center flex-shrink-0`}
                  >
                    {card.svg}
                  </div>
                  {/* Text */}
                  <div>
                    <p
                      className={`font-bold text-[13px] sm:text-[14px] leading-snug mb-1 ${card.textDark ? "text-[#1e4a46]" : "text-white"}`}
                    >
                      {card.title}
                    </p>
                    <p
                      className={`text-[11px] sm:text-[12px] leading-relaxed ${card.textDark ? "text-[#607d7b]" : "text-white/60"}`}
                    >
                      {card.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          FOUNDERS SECTION
          backcover → CSS backgroundImage (original)
          founder1/2/3 → <img> tags (original)
      ══════════════════════════════════════════ */}
      <section
        className="relative py-12 sm:py-16 lg:py-16 text-center text-white overflow-hidden"
        style={{
          backgroundImage: `url(${backcover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-[#162c2a]/85" />
        {/* Plus pattern */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: plusPattern,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        {/* Glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[180px] bg-[#5fbdb3]/10 blur-3xl rounded-full pointer-events-none" />

        <div className="relative max-w-[1200px] mx-auto px-5 sm:px-10 lg:px-20">
          {/* Header */}
          <div className="mb-10 sm:mb-14">
            <div className="flex items-center justify-center gap-3 mb-3">
              <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
              <span className="text-[11px] sm:text-[12px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
                Leadership
              </span>
              <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
            </div>
            <h2 className="font-bold text-[28px] sm:text-[34px] lg:text-[44px] text-white">
              Our Founders
            </h2>
            <p className="mt-2 text-[12px] sm:text-[13px] text-white/50 max-w-[340px] mx-auto">
              The visionaries behind MediSYS Pharmacy's commitment to healthcare
            </p>
          </div>

          {/* Founder cards — 1 col mobile, 3 col sm+ */}
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-10 lg:gap-14">
            {[
              { img: founder1, name: "Dr. Sandra Joseph", role: "Co-founder" },
              { img: founder2, name: "Dr. Rohit Singh", role: "Founder" },
              { img: founder3, name: "Dr. Juli Singh", role: "Co-founder" },
            ].map((f, i) => (
              <div
                key={i}
                className="flex flex-col items-center group max-w-[200px]"
              >
                {/* founder img — same as original, displayed as <img> */}
                <div className="relative">
                  <img
                    src={f.img}
                    alt={f.name}
                    className="w-[140px] h-[185px] sm:w-[155px] sm:h-[200px] lg:w-[165px] lg:h-[215px] object-cover rounded-2xl border-2 border-white/15 shadow-[0_8px_32px_rgba(0,0,0,0.3)] group-hover:border-[#5fbdb3] group-hover:shadow-[0_8px_40px_rgba(95,189,179,0.28)] group-hover:scale-[1.03] transition-all duration-300"
                  />
                  {/* Role badge */}
                  <span className="absolute -top-3 -right-3 bg-[#ff601e] text-white text-[9px] sm:text-[10px] font-bold px-2.5 py-1 rounded-full shadow-[0_3px_10px_rgba(255,96,30,0.45)] whitespace-nowrap">
                    {f.role}
                  </span>
                </div>

                {/* Name — styled like original white card with brand twist */}
                <div className="mt-4 w-full bg-white/[0.09] border border-white/[0.13] rounded-tl-[24px] rounded-br-[24px] py-2.5 px-3 text-center group-hover:bg-white/[0.16] transition-all duration-300">
                  <p className="text-white font-semibold text-[13px] sm:text-[14px] leading-snug">
                    {f.role}: {f.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          STATS SECTION
          vector1/2/3 → <img> tags (original)
      ══════════════════════════════════════════ */}
      <section className="bg-[#f8fafa] py-10 sm:py-14 lg:py-14 px-5 sm:px-10 lg:px-20">
        <div className="max-w-[1200px] mx-auto">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-12">
            <div className="flex items-center justify-center gap-3 mb-2">
              <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
              <span className="text-[11px] sm:text-[12px] font-semibold uppercase tracking-widest text-[#ff601e]">
                Our Impact
              </span>
              <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
            </div>
            <h2 className="font-bold text-[24px] sm:text-[30px] lg:text-[36px] text-[#1e4a46]">
              Trusted by Thousands
            </h2>
          </div>

          {/* Stats — stacked mobile, 3-col sm+ */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
            {[
              {
                img: vector3,
                alt: "Offline Stores",
                number: "100+",
                label: "Offline Stores",
                tColor: "text-[#1e4a46]",
                bar: "from-[#162c2a] to-[#3a7a74]",
                iconBg: "bg-[#eaf4f3]",
              },
              {
                img: vector2,
                alt: "Pincodes Served",
                number: "2000+",
                label: "Pincodes Served",
                tColor: "text-[#ff601e]",
                bar: "from-[#ff601e] to-[#e55519]",
                iconBg: "bg-[#fff3ee]",
              },
              {
                img: vector1,
                alt: "Happy Customers",
                number: "4360+",
                label: "Happy Customers",
                tColor: "text-[#1e4a46]",
                bar: "from-[#1e4a46] to-[#5fbdb3]",
                iconBg: "bg-[#eaf4f3]",
              },
            ].map((s, i) => (
              <div
                key={i}
                className="group relative bg-white border border-[#e2eaea] rounded-2xl p-6 sm:p-7 shadow-[0_2px_12px_rgba(22,44,42,0.07)] hover:shadow-[0_8px_32px_rgba(22,44,42,0.15)] hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <div
                  className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${s.bar}`}
                />
                <div className="flex items-center gap-4 sm:gap-5">
                  <div
                    className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl ${s.iconBg} border border-[#e2eaea] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}
                  >
                    {/* vector imgs displayed as <img> — same as original */}
                    <img
                      src={s.img}
                      alt={s.alt}
                      className="w-7 h-7 sm:w-8 sm:h-8 object-contain"
                    />
                  </div>
                  <div>
                    <p
                      className={`font-bold text-[34px] sm:text-[38px] lg:text-[44px] leading-none ${s.tColor}`}
                    >
                      {s.number}
                    </p>
                    <p className="text-[13px] sm:text-[14px] font-semibold text-[#607d7b] mt-1">
                      {s.label}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          CTA STRIP
      ══════════════════════════════════════════ */}
      <section className="relative overflow-hidden bg-[#162c2a] py-10 sm:py-12 px-5 sm:px-10 lg:px-20">
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: plusPattern,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute right-0 top-0 bottom-0 w-[200px] sm:w-[300px] bg-gradient-to-l from-[#ff601e]/10 to-transparent pointer-events-none" />
        <div className="absolute left-0 top-0 bottom-0 w-[150px] bg-gradient-to-r from-[#5fbdb3]/10 to-transparent pointer-events-none" />

        <div className="relative max-w-[1200px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-5 text-center sm:text-left">
          <div>
            <h3 className="font-bold text-[18px] sm:text-[22px] lg:text-[28px] text-white leading-snug">
              Ready to experience{" "}
              <span className="text-[#5fbdb3]">better healthcare?</span>
            </h3>
            <p className="mt-2 text-[12px] sm:text-[13px] text-white/50">
              Order medicines online and get them delivered to your doorstep.
            </p>
          </div>
          <Link to="/products" className="flex-shrink-0">
            <button className="flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-semibold text-[14px] sm:text-[15px] px-6 sm:px-8 h-[44px] sm:h-[48px] rounded-xl transition-all duration-200 shadow-[0_4px_18px_rgba(255,96,30,0.4)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.55)] hover:-translate-y-0.5 whitespace-nowrap">
              Shop Now
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About_us;
